import { Box, Collapse, Group, Stack, Text } from "@mantine/core"
import { CertificateRequestStatus } from "@tfg/db/browser"
import { Badge, BadgeVariant, ToggleCollapse } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import {
  FindCertificateRequestsByCertificateIdItem,
  FindCertificateRequestsByCertificateIdItemGroup,
} from "~/gen/api"
import { CompletedCertificateRequestCard } from "~/pages/Brand/Certificates/components/CompletedCertificateRequestCard"

export type CompletedCertificateRequestsProps = {
  data: FindCertificateRequestsByCertificateIdItemGroup
  openedStatus: CertificateRequestStatus | null
  setOpenedStatus: React.Dispatch<
    React.SetStateAction<CertificateRequestStatus | null>
  >
}

export const CompletedCertificateRequests: React.FC<
  CompletedCertificateRequestsProps
> = ({
  data,
  openedStatus,
  setOpenedStatus,
}: CompletedCertificateRequestsProps) => {
  const { t } = useTranslation("certificates")

  if (!data.certificateRequests || data.count === 0) {
    return null
  }

  const badgeVariant =
    data.status === CertificateRequestStatus.ACCEPTED
      ? BadgeVariant.SUCCESS
      : BadgeVariant.ERROR

  const seeMoreLabelComponent = (
    <Group gap="xs">
      <Text fw={600} size="md">
        {t(`certificateRequestStatus.${data.status}`)}
      </Text>
      <Badge variant={badgeVariant} text={data.count.toString()} size="xs" />
    </Group>
  )

  const opened = openedStatus === data.status
  const toggle = () => {
    setOpenedStatus(opened ? null : data.status)
  }

  return (
    <Stack h="fit-content" gap={0}>
      <ToggleCollapse
        open={opened}
        toggle={toggle}
        seeMoreLabel={seeMoreLabelComponent}
        seeLessLabel={seeMoreLabelComponent}
      />
      <Collapse in={opened}>
        <Box mah="calc(100vh - 15rem)" style={{ overflowY: "auto" }}>
          {data.certificateRequests.map(
            (
              certificateRequest: FindCertificateRequestsByCertificateIdItem
            ) => (
              <CompletedCertificateRequestCard
                key={certificateRequest.id}
                certificateRequest={certificateRequest}
              />
            )
          )}
        </Box>
      </Collapse>
    </Stack>
  )
}
